import type {Values} from "@wix/devzai-utils-common";

export const DoppeFormRequiredMarkingMode = {
    Asterisk: 'Asterisk',
    RequiredLabel: 'RequiredLabel',
    OptionalLabel: 'OptionalLabel',
    None: 'None',
} as const;

export type DoppeFormRequiredMarkingMode = Values<typeof DoppeFormRequiredMarkingMode>;
